import { render, staticRenderFns } from "./activity-list-eio.vue?vue&type=template&id=0b58e1fa&scoped=true"
import script from "./activity-list-eio.vue?vue&type=script&lang=js"
export * from "./activity-list-eio.vue?vue&type=script&lang=js"
import style0 from "./activity-list-eio.vue?vue&type=style&index=0&id=0b58e1fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b58e1fa",
  null
  
)

export default component.exports